<template>
<transition name="slide-fade">
    <div class="dialog-view" v-show="visible">        
        <div class="rule-modal u-window">           
            <div class="dialog-content">              
                <div class="u-btn close" @click="destroyElement"></div>
                <div class="dialog-wrapper">
                    <div class="dialog-title t-rule"></div>

                    <div class="rules">
                        <div class="rule-text">
                            <div v-for="(item,index) in rule" :key="index">
                                <em class="tag" :class="'t-' + (index + 1)" v-html="index+1"></em>
                                <p v-html="item.text"></p>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
export default {
    name : 'evt_rule_modal',
    data : function () {
        return {
            visible : false,
            evt_time : '6月8日—7月5日',
            rule_text :{
                'evt' : [
                    {
                        tag : '',
                        text : '被招募时的等级需≥11级，历史充值达到要求',
                    },
                    {
                        tag : '',
                        text : '回归玩家或满足截止至2023年12月14日超过30天未登录游戏的玩家。',
                    },
                    {
                        tag : '',
                        text : '每位玩家最多可招募4位回归玩家参与活动。',
                    },
                    // {
                    //     tag : '',
                    //     text : '小黄是猪',
                    // },                                                                                                                                     
                ],
                'share' : [
                    {
                        tag : '活动时间',
                        text : '2022/10/31 至 2022/11/7',
                    },
                    {
                        tag : '玩法说明',
                        text : '活动期间,分享页面,当其他仙术师通过分享链接登录界面即为助力成功。',
                    },                   
                ],
            },
            type : 'evt',          
        }
    },
    computed :{
        rule (newVal){
            return this.rule_text[this.type]
        },        
    },
    created(){
        document.body.style.overflow = 'hidden';
    },  
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    methods: {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
    }    
}
</script>

<style scoped>

    .rule-modal{
        width: 629px;
        height: 379px;      
        background-image: url(~@/assets/images/modal/bg-modal-rule.png);
    }


    .t-rule{
        width: 516px;
        height: 54px;
        margin: 0 auto 30px;
        background-image: url(~@/assets/images/modal/title-rule.png);
    }

    .rule-modal .dialog-wrapper{
        /* padding: 20px 0 0; */
    }

    .rule-text{
        padding: 0 50px;
    }
    
    .rule-text>div{
        position: relative;
        line-height: 1.4;
        padding-left: 50px;
        margin-bottom: 30px;
        font-size: 22px;
        color: #49392e;
    }

    .rule-modal .tag{
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 33px;
        height: 33px;
        line-height: 33px;
        border-radius: 50%;
        text-align: center;
        background-color: #c0a482;
        color: #fff;
    }

    .rule-modal .tag-text{
        margin-bottom: 12px;
        font-weight: 700;
        color: #fcf6d7;
    }
</style>


// WEBPACK FOOTER //
// src/components/EvtRule/EvtRule.vue